export default __webpack_public_path__ + "static/media/mobile_account_icon.2b1935d2.svg";